webpackJsonp([5],{

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

var checkAndBuildOpts = __webpack_require__(5);
var LegendManager = __webpack_require__(1423);

var REQUIRED_OPTS = [
  'deepInsightsDashboard',
  'layerStyleCollection'
];

/**
 * Integration between embed view with cartodb.js and deep-insights.
 */
var F = function (opts) {
  checkAndBuildOpts(opts, REQUIRED_OPTS, this);

  this._getWidgets().each(function (m) {
    this._bindWidgetChanges(m);
  }, this);

  LegendManager.trackLegends(this._getLayers());
};

F.prototype._bindWidgetChanges = function (m) {
  // wait until the widget has the state from the url
  m.bind('change:hasInitialState', function (m) {
    m.bind('change:autoStyle', this._onWidgetAutoStyleChanged, this);

    // In order to trigger legend update, we wait until the cartocss from autostyle is applied
    if (m.isAutoStyle()) {
      if (!m.layerModel.get('initialStyle')) {
        m.layerModel.once('change:initialStyle', function () {
          this._onWidgetAutoStyleChanged(m);
        }, this);
      } else {
        this._onWidgetAutoStyleChanged(m);
      }
    }
  }, this);
};

F.prototype._onWidgetAutoStyleChanged = function (m) {
  var isAnyAutoStyleApplied = this._getWidgets().any(function (m) {
    return m.isAutoStyle();
  }, this);

  var isAutoStyleApplied = m.isAutoStyle();
  var layerId = m.layerModel.id;
  var layerStyle;

  if (isAutoStyleApplied) {
    LegendManager.updateLegends(layerId);

    layerStyle = this._layerStyleCollection.findById(layerId);
    // setting this in order to restore initial style when disable autostyle
    if (m.layerModel) {
      m.layerModel.attributes.initialStyle = layerStyle.get('cartocss');
    }
  } else if (!isAnyAutoStyleApplied) {
    LegendManager.resetLegends(layerId);
  }
};

F.prototype._getLayer = function (m) {
  return this.visMap().getLayerById(m.id);
};

F.prototype._getLayers = function (m) {
  return this.visMap().layers;
};

F.prototype.visMap = function () {
  return this._vis().map;
};

F.prototype._getWidgets = function (m) {
  return this._deepInsightsDashboard._dashboard.widgets._widgetsCollection;
};

F.prototype._vis = function () {
  return this._deepInsightsDashboard.getMap();
};

module.exports = F;


/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
module.exports = Backbone.Collection.extend({
  model: function (d, opts) {
    var attrs = {};
    attrs.id = d.id;
    if (d.options.tile_style) {
      attrs.cartocss = d.options.tile_style;
    }
    return new Backbone.Model(attrs);
  },

  resetByLayersData: function (data) {
    this.reset(data, {
      silent: true
    });
  },

  findById: function (id) {
    return this.findWhere({id: id});
  }
});


/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 143,
	"./af.js": 143,
	"./ar": 150,
	"./ar-dz": 144,
	"./ar-dz.js": 144,
	"./ar-kw": 145,
	"./ar-kw.js": 145,
	"./ar-ly": 146,
	"./ar-ly.js": 146,
	"./ar-ma": 147,
	"./ar-ma.js": 147,
	"./ar-sa": 148,
	"./ar-sa.js": 148,
	"./ar-tn": 149,
	"./ar-tn.js": 149,
	"./ar.js": 150,
	"./az": 151,
	"./az.js": 151,
	"./be": 152,
	"./be.js": 152,
	"./bg": 153,
	"./bg.js": 153,
	"./bn": 154,
	"./bn.js": 154,
	"./bo": 155,
	"./bo.js": 155,
	"./br": 156,
	"./br.js": 156,
	"./bs": 157,
	"./bs.js": 157,
	"./ca": 158,
	"./ca.js": 158,
	"./cs": 159,
	"./cs.js": 159,
	"./cv": 160,
	"./cv.js": 160,
	"./cy": 161,
	"./cy.js": 161,
	"./da": 162,
	"./da.js": 162,
	"./de": 165,
	"./de-at": 163,
	"./de-at.js": 163,
	"./de-ch": 164,
	"./de-ch.js": 164,
	"./de.js": 165,
	"./dv": 166,
	"./dv.js": 166,
	"./el": 167,
	"./el.js": 167,
	"./en-au": 168,
	"./en-au.js": 168,
	"./en-ca": 169,
	"./en-ca.js": 169,
	"./en-gb": 170,
	"./en-gb.js": 170,
	"./en-ie": 171,
	"./en-ie.js": 171,
	"./en-nz": 172,
	"./en-nz.js": 172,
	"./eo": 173,
	"./eo.js": 173,
	"./es": 175,
	"./es-do": 174,
	"./es-do.js": 174,
	"./es.js": 175,
	"./et": 176,
	"./et.js": 176,
	"./eu": 177,
	"./eu.js": 177,
	"./fa": 178,
	"./fa.js": 178,
	"./fi": 179,
	"./fi.js": 179,
	"./fo": 180,
	"./fo.js": 180,
	"./fr": 183,
	"./fr-ca": 181,
	"./fr-ca.js": 181,
	"./fr-ch": 182,
	"./fr-ch.js": 182,
	"./fr.js": 183,
	"./fy": 184,
	"./fy.js": 184,
	"./gd": 185,
	"./gd.js": 185,
	"./gl": 186,
	"./gl.js": 186,
	"./gom-latn": 187,
	"./gom-latn.js": 187,
	"./he": 188,
	"./he.js": 188,
	"./hi": 189,
	"./hi.js": 189,
	"./hr": 190,
	"./hr.js": 190,
	"./hu": 191,
	"./hu.js": 191,
	"./hy-am": 192,
	"./hy-am.js": 192,
	"./id": 193,
	"./id.js": 193,
	"./is": 194,
	"./is.js": 194,
	"./it": 195,
	"./it.js": 195,
	"./ja": 196,
	"./ja.js": 196,
	"./jv": 197,
	"./jv.js": 197,
	"./ka": 198,
	"./ka.js": 198,
	"./kk": 199,
	"./kk.js": 199,
	"./km": 200,
	"./km.js": 200,
	"./kn": 201,
	"./kn.js": 201,
	"./ko": 202,
	"./ko.js": 202,
	"./ky": 203,
	"./ky.js": 203,
	"./lb": 204,
	"./lb.js": 204,
	"./lo": 205,
	"./lo.js": 205,
	"./lt": 206,
	"./lt.js": 206,
	"./lv": 207,
	"./lv.js": 207,
	"./me": 208,
	"./me.js": 208,
	"./mi": 209,
	"./mi.js": 209,
	"./mk": 210,
	"./mk.js": 210,
	"./ml": 211,
	"./ml.js": 211,
	"./mr": 212,
	"./mr.js": 212,
	"./ms": 214,
	"./ms-my": 213,
	"./ms-my.js": 213,
	"./ms.js": 214,
	"./my": 215,
	"./my.js": 215,
	"./nb": 216,
	"./nb.js": 216,
	"./ne": 217,
	"./ne.js": 217,
	"./nl": 219,
	"./nl-be": 218,
	"./nl-be.js": 218,
	"./nl.js": 219,
	"./nn": 220,
	"./nn.js": 220,
	"./pa-in": 221,
	"./pa-in.js": 221,
	"./pl": 222,
	"./pl.js": 222,
	"./pt": 224,
	"./pt-br": 223,
	"./pt-br.js": 223,
	"./pt.js": 224,
	"./ro": 225,
	"./ro.js": 225,
	"./ru": 226,
	"./ru.js": 226,
	"./sd": 227,
	"./sd.js": 227,
	"./se": 228,
	"./se.js": 228,
	"./si": 229,
	"./si.js": 229,
	"./sk": 230,
	"./sk.js": 230,
	"./sl": 231,
	"./sl.js": 231,
	"./sq": 232,
	"./sq.js": 232,
	"./sr": 234,
	"./sr-cyrl": 233,
	"./sr-cyrl.js": 233,
	"./sr.js": 234,
	"./ss": 235,
	"./ss.js": 235,
	"./sv": 236,
	"./sv.js": 236,
	"./sw": 237,
	"./sw.js": 237,
	"./ta": 238,
	"./ta.js": 238,
	"./te": 239,
	"./te.js": 239,
	"./tet": 240,
	"./tet.js": 240,
	"./th": 241,
	"./th.js": 241,
	"./tl-ph": 242,
	"./tl-ph.js": 242,
	"./tlh": 243,
	"./tlh.js": 243,
	"./tr": 244,
	"./tr.js": 244,
	"./tzl": 245,
	"./tzl.js": 245,
	"./tzm": 247,
	"./tzm-latn": 246,
	"./tzm-latn.js": 246,
	"./tzm.js": 247,
	"./uk": 248,
	"./uk.js": 248,
	"./ur": 249,
	"./ur.js": 249,
	"./uz": 251,
	"./uz-latn": 250,
	"./uz-latn.js": 250,
	"./uz.js": 251,
	"./vi": 252,
	"./vi.js": 252,
	"./x-pseudo": 253,
	"./x-pseudo.js": 253,
	"./yo": 254,
	"./yo.js": 254,
	"./zh-cn": 255,
	"./zh-cn.js": 255,
	"./zh-hk": 256,
	"./zh-hk.js": 256,
	"./zh-tw": 257,
	"./zh-tw.js": 257
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var legendsMetadata = __webpack_require__(586);

var legends;

var LEGENDS_METADATA = _.keys(legendsMetadata);
var LEGENDS_COLOR = ['category', 'choropleth'];

var LegendManager = {
  trackLegends: function (layers) {
    legends = {};

    _.each(layers.models, function (layer) {
      var legendsLayer;
      var o = {};
      if (layer.legends != null) {
        legendsLayer = layer.legends;
        _.each(LEGENDS_METADATA, function (legend) {
          var m = legendsLayer[legend];
          if (m.get('visible') === true) {
            o[legend] = m;
          }
        });
        legends[layer.id] = o;
      }
    });
  },

  getLegends: function () {
    return legends;
  },

  updateLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(LEGENDS_COLOR, function (legend) {
      var m = legendsLayer[legend];
      m && m.set({visible: false});
    });
  },

  resetLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(legendsLayer, function (legend) {
      legend.set({visible: true});
    });
  }
};

module.exports = LegendManager;


/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

var deepInsights = __webpack_require__(354);
var LayerStyleCollection = __webpack_require__(1090);
var EmbedIntegrations = __webpack_require__(1089);

var _ = __webpack_require__(0);
var URLStateHelper = __webpack_require__(133);
var vizJSON = window.vizJSON;
var cartoLogoOption = _.findWhere(vizJSON.overlays, {type: 'logo'});
var dashboardOpts = {
  no_cdn: false,
  cartodb_logo: cartoLogoOption !== undefined,
  renderMenu: vizJSON.options.dashboard_menu,
  share_urls: true,
  authToken: window.authTokens,
  layerSelectorEnabled: true,
  mapzenApiKey: window.mapzenApiKey
};
var stateJSON = window.stateJSON;
var layersData = window.layersData;

var stateFromURL = URLStateHelper.getStateFromCurrentURL();
if (stateFromURL && !_.isEmpty(stateFromURL)) {
  _.extend(dashboardOpts, {
    state: stateFromURL
  });
} else if (stateJSON && stateJSON !== '{}') {
  _.extend(dashboardOpts, {
    state: stateJSON
  });
}

var layerStyleCollection = new LayerStyleCollection();
layerStyleCollection.resetByLayersData(layersData);

deepInsights.createDashboard('#dashboard', vizJSON, dashboardOpts, function (error, dashboard) {
  if (error) {
    console.error('Dashboard has some errors:', error);
  }

  var map = dashboard.getMap().map;
  var scrollwheel = vizJSON.options.scrollwheel;
  var method = scrollwheel ? 'enableScrollWheel' : 'disableScrollWheel';
  map && map[method] && map[method]();

  var embedIntegrations = new EmbedIntegrations({
    deepInsightsDashboard: dashboard,
    layerStyleCollection: layerStyleCollection
  });

  window.embedIntegrations = embedIntegrations;
});

window.layerStyleCollection = layerStyleCollection;


/***/ }),

/***/ 381:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 381;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);

module.exports = function checkAndBuildRequiredOpts (actualOpts, requiredOpts, context) {
  if (requiredOpts === void 0) {
    throw new Error('Opts are required');
  }

  _.each(requiredOpts, function (item) {
    if (actualOpts[item] === void 0) throw new Error(item + ' is required');
    context['_' + item] = actualOpts[item];
  }, context);
};


/***/ }),

/***/ 586:
/***/ (function(module, exports) {

var LEGENDS_METADATA = {
  bubble: {
    legendType: 'size'
  },
  category: {
    legendType: 'color'
  },
  choropleth: {
    legendType: 'color'
  },
  custom: {
    legendType: 'color'
  },
  custom_choropleth: {
    legendType: 'color'
  }
};

module.exports = LEGENDS_METADATA;


/***/ }),

/***/ 918:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[1431]);


// WEBPACK FOOTER //
// 4.10.61/javascripts/builder_embed.js